import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughMessengerInputProps = {
  node: ConversationFlowAuditLogEntry<'MESSENGER_INPUT_FIELD_NODE_VISITED'>;
};

export function RoutedThroughMessengerInput({
  node,
}: RoutedThroughMessengerInputProps): JSX.Element {
  return (
    <>
      Input · <strong>{node.input}</strong>
    </>
  );
}
